import { render, staticRenderFns } from "./modular_admin.vue?vue&type=template&id=2bfe0169&scoped=true&"
import script from "./modular_admin.vue?vue&type=script&lang=js&"
export * from "./modular_admin.vue?vue&type=script&lang=js&"
import style0 from "./modular_admin.vue?vue&type=style&index=0&lang=css&"
import style1 from "./modular_admin.vue?vue&type=style&index=1&id=2bfe0169&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfe0169",
  null
  
)

export default component.exports